export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
  REDIRECT_ON_OPTIONS: {"ALL":"all","ROOT":"root","NO_PREFIX":"no prefix"},
}
export const nuxtOptions = {
  isUniversalMode: true,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: {"fallbackLocale":{"default":["en","he"]},"silentTranslationWarn":true},
  vueI18nLoader: false,
  locales: [{"code":"he","name":"עברית","iso":"he-IL","file":"he-IL.js","dir":"rtl"},{"code":"en","name":"English","iso":"en-US","file":"en-US.js"},{"code":"fr","name":"français","iso":"fr-FR","file":"fr-FR.js"},{"code":"es","name":"español","iso":"es-ES","file":"es-ES.js"},{"code":"ar","name":"العربية","iso":"ar-AE","file":"ar-SA.js","dir":"rtl"},{"code":"ru","name":"русский","iso":"ru-RU","file":"ru-RU.js"},{"code":"id","name":"Bahasa Indonesia","iso":"id-ID","file":"id-ID.js"},{"code":"ms","name":"Bahasa Melayu","iso":"ms-MY","file":"ms-MY.js"},{"code":"ca","name":"català","iso":"ca-ES","file":"ca-ES.js"},{"code":"da","name":"dansk","iso":"da-DK","file":"da-DK.js"},{"code":"de","name":"Deutsch","iso":"de-DE","file":"de-DE.js"},{"code":"et","name":"eesti","iso":"et-EE","file":"et-EE.js"},{"code":"hr","name":"hrvatski","iso":"hr-HR","file":"hr-HR.js"},{"code":"it","name":"italiano","iso":"it-IT","file":"it-IT.js"},{"code":"lt","name":"lietuvių","iso":"lt-LT","file":"lt-LT.js"},{"code":"hu","name":"magyar","iso":"hu-HU","file":"hu-HU.js"},{"code":"nl","name":"Nederlands","iso":"nl-NL","file":"nl-NL.js"},{"code":"pl","name":"polski","iso":"pl-PL","file":"pl-PL.js"},{"code":"pt","name":"português","iso":"pt-PT","file":"pt-PT.js"},{"code":"pt-br","name":"português do Brasil","iso":"pt-BR","file":"pt-BR.js"},{"code":"ro","name":"română","iso":"ro-RO","file":"ro-RO.js"},{"code":"sk","name":"slovenčina","iso":"sk-SK","file":"sk-SK.js"},{"code":"sl","name":"slovenščina","iso":"sl-SI","file":"sl-SI.js"},{"code":"fi","name":"suomi","iso":"fi-FI","file":"fi-FI.js"},{"code":"sv","name":"svenska","iso":"sv-SE","file":"sv-SE.js"},{"code":"vi","name":"Tiếng Việt","iso":"vi-VN","file":"vi-VN.js"},{"code":"tr","name":"Türkçe","iso":"tr-TR","file":"tr-TR.js"},{"code":"is","name":"íslenska","iso":"is-IS","file":"is-IS.js"},{"code":"cs","name":"čeština","iso":"cs-CZ","file":"cs-CZ.js"},{"code":"el","name":"Ελληνικά","iso":"el-GR","file":"el-GR.js"},{"code":"sr","name":"Srpski","iso":"sr-RS","file":"sr-SP.js"},{"code":"bg","name":"български","iso":"bg-BG","file":"bg-BG.js"},{"code":"tl-ph","name":"Tagalog","iso":"tl-PH","file":"tl-PH.js"},{"code":"uk","name":"українська","iso":"uk-UA","file":"uk-UA.js"},{"code":"th","name":"ไทย","iso":"th-TH","file":"th-TH.js"},{"code":"ja","name":"日本語","iso":"ja-JP","file":"ja-JP.js"},{"code":"zh-cn","name":"简体中文","iso":"zh-CN","file":"zh-CN.js"},{"code":"zh-tw","name":"繁體中文","iso":"zh-TW","file":"zh-TW.js"},{"code":"ko","name":"한국어","iso":"ko-KR","file":"ko-KR.js"}],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "lang/",
  rootRedirect: null,
  detectBrowserLanguage: {"alwaysRedirect":true,"cookieAge":365,"cookieCrossOrigin":false,"cookieDomain":null,"cookieKey":"i18n_redirected","cookieSecure":false,"fallbackLocale":"","redirectOn":"root","useCookie":true,"onlyOnRoot":true},
  differentDomains: false,
  baseUrl: "",
  vuex: {"moduleName":"i18n","syncRouteParams":true},
  parsePages: true,
  pages: {},
  skipSettingLocaleOnNavigate: false,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  normalizedLocales: [{"code":"he","name":"עברית","iso":"he-IL","file":"he-IL.js","dir":"rtl"},{"code":"en","name":"English","iso":"en-US","file":"en-US.js"},{"code":"fr","name":"français","iso":"fr-FR","file":"fr-FR.js"},{"code":"es","name":"español","iso":"es-ES","file":"es-ES.js"},{"code":"ar","name":"العربية","iso":"ar-AE","file":"ar-SA.js","dir":"rtl"},{"code":"ru","name":"русский","iso":"ru-RU","file":"ru-RU.js"},{"code":"id","name":"Bahasa Indonesia","iso":"id-ID","file":"id-ID.js"},{"code":"ms","name":"Bahasa Melayu","iso":"ms-MY","file":"ms-MY.js"},{"code":"ca","name":"català","iso":"ca-ES","file":"ca-ES.js"},{"code":"da","name":"dansk","iso":"da-DK","file":"da-DK.js"},{"code":"de","name":"Deutsch","iso":"de-DE","file":"de-DE.js"},{"code":"et","name":"eesti","iso":"et-EE","file":"et-EE.js"},{"code":"hr","name":"hrvatski","iso":"hr-HR","file":"hr-HR.js"},{"code":"it","name":"italiano","iso":"it-IT","file":"it-IT.js"},{"code":"lt","name":"lietuvių","iso":"lt-LT","file":"lt-LT.js"},{"code":"hu","name":"magyar","iso":"hu-HU","file":"hu-HU.js"},{"code":"nl","name":"Nederlands","iso":"nl-NL","file":"nl-NL.js"},{"code":"pl","name":"polski","iso":"pl-PL","file":"pl-PL.js"},{"code":"pt","name":"português","iso":"pt-PT","file":"pt-PT.js"},{"code":"pt-br","name":"português do Brasil","iso":"pt-BR","file":"pt-BR.js"},{"code":"ro","name":"română","iso":"ro-RO","file":"ro-RO.js"},{"code":"sk","name":"slovenčina","iso":"sk-SK","file":"sk-SK.js"},{"code":"sl","name":"slovenščina","iso":"sl-SI","file":"sl-SI.js"},{"code":"fi","name":"suomi","iso":"fi-FI","file":"fi-FI.js"},{"code":"sv","name":"svenska","iso":"sv-SE","file":"sv-SE.js"},{"code":"vi","name":"Tiếng Việt","iso":"vi-VN","file":"vi-VN.js"},{"code":"tr","name":"Türkçe","iso":"tr-TR","file":"tr-TR.js"},{"code":"is","name":"íslenska","iso":"is-IS","file":"is-IS.js"},{"code":"cs","name":"čeština","iso":"cs-CZ","file":"cs-CZ.js"},{"code":"el","name":"Ελληνικά","iso":"el-GR","file":"el-GR.js"},{"code":"sr","name":"Srpski","iso":"sr-RS","file":"sr-SP.js"},{"code":"bg","name":"български","iso":"bg-BG","file":"bg-BG.js"},{"code":"tl-ph","name":"Tagalog","iso":"tl-PH","file":"tl-PH.js"},{"code":"uk","name":"українська","iso":"uk-UA","file":"uk-UA.js"},{"code":"th","name":"ไทย","iso":"th-TH","file":"th-TH.js"},{"code":"ja","name":"日本語","iso":"ja-JP","file":"ja-JP.js"},{"code":"zh-cn","name":"简体中文","iso":"zh-CN","file":"zh-CN.js"},{"code":"zh-tw","name":"繁體中文","iso":"zh-TW","file":"zh-TW.js"},{"code":"ko","name":"한국어","iso":"ko-KR","file":"ko-KR.js"}],
  localeCodes: ["he","en","fr","es","ar","ru","id","ms","ca","da","de","et","hr","it","lt","hu","nl","pl","pt","pt-br","ro","sk","sl","fi","sv","vi","tr","is","cs","el","sr","bg","tl-ph","uk","th","ja","zh-cn","zh-tw","ko"],
  additionalMessages: [],
}
export const localeFiles = {
  0: "{",
  1: "\"",
  2: "h",
  3: "e",
  4: "-",
  5: "I",
  6: "L",
  7: ".",
  8: "j",
  9: "s",
  10: "\"",
  11: ":",
  12: "\"",
  13: ".",
  14: ".",
  15: "/",
  16: "l",
  17: "a",
  18: "n",
  19: "g",
  20: "/",
  21: "h",
  22: "e",
  23: "-",
  24: "I",
  25: "L",
  26: ".",
  27: "j",
  28: "s",
  29: "\"",
  30: ",",
  31: "\"",
  32: "e",
  33: "n",
  34: "-",
  35: "U",
  36: "S",
  37: ".",
  38: "j",
  39: "s",
  40: "\"",
  41: ":",
  42: "\"",
  43: ".",
  44: ".",
  45: "/",
  46: "l",
  47: "a",
  48: "n",
  49: "g",
  50: "/",
  51: "e",
  52: "n",
  53: "-",
  54: "U",
  55: "S",
  56: ".",
  57: "j",
  58: "s",
  59: "\"",
  60: ",",
  61: "\"",
  62: "f",
  63: "r",
  64: "-",
  65: "F",
  66: "R",
  67: ".",
  68: "j",
  69: "s",
  70: "\"",
  71: ":",
  72: "\"",
  73: ".",
  74: ".",
  75: "/",
  76: "l",
  77: "a",
  78: "n",
  79: "g",
  80: "/",
  81: "f",
  82: "r",
  83: "-",
  84: "F",
  85: "R",
  86: ".",
  87: "j",
  88: "s",
  89: "\"",
  90: ",",
  91: "\"",
  92: "e",
  93: "s",
  94: "-",
  95: "E",
  96: "S",
  97: ".",
  98: "j",
  99: "s",
  100: "\"",
  101: ":",
  102: "\"",
  103: ".",
  104: ".",
  105: "/",
  106: "l",
  107: "a",
  108: "n",
  109: "g",
  110: "/",
  111: "e",
  112: "s",
  113: "-",
  114: "E",
  115: "S",
  116: ".",
  117: "j",
  118: "s",
  119: "\"",
  120: ",",
  121: "\"",
  122: "a",
  123: "r",
  124: "-",
  125: "S",
  126: "A",
  127: ".",
  128: "j",
  129: "s",
  130: "\"",
  131: ":",
  132: "\"",
  133: ".",
  134: ".",
  135: "/",
  136: "l",
  137: "a",
  138: "n",
  139: "g",
  140: "/",
  141: "a",
  142: "r",
  143: "-",
  144: "S",
  145: "A",
  146: ".",
  147: "j",
  148: "s",
  149: "\"",
  150: ",",
  151: "\"",
  152: "r",
  153: "u",
  154: "-",
  155: "R",
  156: "U",
  157: ".",
  158: "j",
  159: "s",
  160: "\"",
  161: ":",
  162: "\"",
  163: ".",
  164: ".",
  165: "/",
  166: "l",
  167: "a",
  168: "n",
  169: "g",
  170: "/",
  171: "r",
  172: "u",
  173: "-",
  174: "R",
  175: "U",
  176: ".",
  177: "j",
  178: "s",
  179: "\"",
  180: ",",
  181: "\"",
  182: "i",
  183: "d",
  184: "-",
  185: "I",
  186: "D",
  187: ".",
  188: "j",
  189: "s",
  190: "\"",
  191: ":",
  192: "\"",
  193: ".",
  194: ".",
  195: "/",
  196: "l",
  197: "a",
  198: "n",
  199: "g",
  200: "/",
  201: "i",
  202: "d",
  203: "-",
  204: "I",
  205: "D",
  206: ".",
  207: "j",
  208: "s",
  209: "\"",
  210: ",",
  211: "\"",
  212: "m",
  213: "s",
  214: "-",
  215: "M",
  216: "Y",
  217: ".",
  218: "j",
  219: "s",
  220: "\"",
  221: ":",
  222: "\"",
  223: ".",
  224: ".",
  225: "/",
  226: "l",
  227: "a",
  228: "n",
  229: "g",
  230: "/",
  231: "m",
  232: "s",
  233: "-",
  234: "M",
  235: "Y",
  236: ".",
  237: "j",
  238: "s",
  239: "\"",
  240: ",",
  241: "\"",
  242: "c",
  243: "a",
  244: "-",
  245: "E",
  246: "S",
  247: ".",
  248: "j",
  249: "s",
  250: "\"",
  251: ":",
  252: "\"",
  253: ".",
  254: ".",
  255: "/",
  256: "l",
  257: "a",
  258: "n",
  259: "g",
  260: "/",
  261: "c",
  262: "a",
  263: "-",
  264: "E",
  265: "S",
  266: ".",
  267: "j",
  268: "s",
  269: "\"",
  270: ",",
  271: "\"",
  272: "d",
  273: "a",
  274: "-",
  275: "D",
  276: "K",
  277: ".",
  278: "j",
  279: "s",
  280: "\"",
  281: ":",
  282: "\"",
  283: ".",
  284: ".",
  285: "/",
  286: "l",
  287: "a",
  288: "n",
  289: "g",
  290: "/",
  291: "d",
  292: "a",
  293: "-",
  294: "D",
  295: "K",
  296: ".",
  297: "j",
  298: "s",
  299: "\"",
  300: ",",
  301: "\"",
  302: "d",
  303: "e",
  304: "-",
  305: "D",
  306: "E",
  307: ".",
  308: "j",
  309: "s",
  310: "\"",
  311: ":",
  312: "\"",
  313: ".",
  314: ".",
  315: "/",
  316: "l",
  317: "a",
  318: "n",
  319: "g",
  320: "/",
  321: "d",
  322: "e",
  323: "-",
  324: "D",
  325: "E",
  326: ".",
  327: "j",
  328: "s",
  329: "\"",
  330: ",",
  331: "\"",
  332: "e",
  333: "t",
  334: "-",
  335: "E",
  336: "E",
  337: ".",
  338: "j",
  339: "s",
  340: "\"",
  341: ":",
  342: "\"",
  343: ".",
  344: ".",
  345: "/",
  346: "l",
  347: "a",
  348: "n",
  349: "g",
  350: "/",
  351: "e",
  352: "t",
  353: "-",
  354: "E",
  355: "E",
  356: ".",
  357: "j",
  358: "s",
  359: "\"",
  360: ",",
  361: "\"",
  362: "h",
  363: "r",
  364: "-",
  365: "H",
  366: "R",
  367: ".",
  368: "j",
  369: "s",
  370: "\"",
  371: ":",
  372: "\"",
  373: ".",
  374: ".",
  375: "/",
  376: "l",
  377: "a",
  378: "n",
  379: "g",
  380: "/",
  381: "h",
  382: "r",
  383: "-",
  384: "H",
  385: "R",
  386: ".",
  387: "j",
  388: "s",
  389: "\"",
  390: ",",
  391: "\"",
  392: "i",
  393: "t",
  394: "-",
  395: "I",
  396: "T",
  397: ".",
  398: "j",
  399: "s",
  400: "\"",
  401: ":",
  402: "\"",
  403: ".",
  404: ".",
  405: "/",
  406: "l",
  407: "a",
  408: "n",
  409: "g",
  410: "/",
  411: "i",
  412: "t",
  413: "-",
  414: "I",
  415: "T",
  416: ".",
  417: "j",
  418: "s",
  419: "\"",
  420: ",",
  421: "\"",
  422: "l",
  423: "t",
  424: "-",
  425: "L",
  426: "T",
  427: ".",
  428: "j",
  429: "s",
  430: "\"",
  431: ":",
  432: "\"",
  433: ".",
  434: ".",
  435: "/",
  436: "l",
  437: "a",
  438: "n",
  439: "g",
  440: "/",
  441: "l",
  442: "t",
  443: "-",
  444: "L",
  445: "T",
  446: ".",
  447: "j",
  448: "s",
  449: "\"",
  450: ",",
  451: "\"",
  452: "h",
  453: "u",
  454: "-",
  455: "H",
  456: "U",
  457: ".",
  458: "j",
  459: "s",
  460: "\"",
  461: ":",
  462: "\"",
  463: ".",
  464: ".",
  465: "/",
  466: "l",
  467: "a",
  468: "n",
  469: "g",
  470: "/",
  471: "h",
  472: "u",
  473: "-",
  474: "H",
  475: "U",
  476: ".",
  477: "j",
  478: "s",
  479: "\"",
  480: ",",
  481: "\"",
  482: "n",
  483: "l",
  484: "-",
  485: "N",
  486: "L",
  487: ".",
  488: "j",
  489: "s",
  490: "\"",
  491: ":",
  492: "\"",
  493: ".",
  494: ".",
  495: "/",
  496: "l",
  497: "a",
  498: "n",
  499: "g",
  500: "/",
  501: "n",
  502: "l",
  503: "-",
  504: "N",
  505: "L",
  506: ".",
  507: "j",
  508: "s",
  509: "\"",
  510: ",",
  511: "\"",
  512: "p",
  513: "l",
  514: "-",
  515: "P",
  516: "L",
  517: ".",
  518: "j",
  519: "s",
  520: "\"",
  521: ":",
  522: "\"",
  523: ".",
  524: ".",
  525: "/",
  526: "l",
  527: "a",
  528: "n",
  529: "g",
  530: "/",
  531: "p",
  532: "l",
  533: "-",
  534: "P",
  535: "L",
  536: ".",
  537: "j",
  538: "s",
  539: "\"",
  540: ",",
  541: "\"",
  542: "p",
  543: "t",
  544: "-",
  545: "P",
  546: "T",
  547: ".",
  548: "j",
  549: "s",
  550: "\"",
  551: ":",
  552: "\"",
  553: ".",
  554: ".",
  555: "/",
  556: "l",
  557: "a",
  558: "n",
  559: "g",
  560: "/",
  561: "p",
  562: "t",
  563: "-",
  564: "P",
  565: "T",
  566: ".",
  567: "j",
  568: "s",
  569: "\"",
  570: ",",
  571: "\"",
  572: "p",
  573: "t",
  574: "-",
  575: "B",
  576: "R",
  577: ".",
  578: "j",
  579: "s",
  580: "\"",
  581: ":",
  582: "\"",
  583: ".",
  584: ".",
  585: "/",
  586: "l",
  587: "a",
  588: "n",
  589: "g",
  590: "/",
  591: "p",
  592: "t",
  593: "-",
  594: "B",
  595: "R",
  596: ".",
  597: "j",
  598: "s",
  599: "\"",
  600: ",",
  601: "\"",
  602: "r",
  603: "o",
  604: "-",
  605: "R",
  606: "O",
  607: ".",
  608: "j",
  609: "s",
  610: "\"",
  611: ":",
  612: "\"",
  613: ".",
  614: ".",
  615: "/",
  616: "l",
  617: "a",
  618: "n",
  619: "g",
  620: "/",
  621: "r",
  622: "o",
  623: "-",
  624: "R",
  625: "O",
  626: ".",
  627: "j",
  628: "s",
  629: "\"",
  630: ",",
  631: "\"",
  632: "s",
  633: "k",
  634: "-",
  635: "S",
  636: "K",
  637: ".",
  638: "j",
  639: "s",
  640: "\"",
  641: ":",
  642: "\"",
  643: ".",
  644: ".",
  645: "/",
  646: "l",
  647: "a",
  648: "n",
  649: "g",
  650: "/",
  651: "s",
  652: "k",
  653: "-",
  654: "S",
  655: "K",
  656: ".",
  657: "j",
  658: "s",
  659: "\"",
  660: ",",
  661: "\"",
  662: "s",
  663: "l",
  664: "-",
  665: "S",
  666: "I",
  667: ".",
  668: "j",
  669: "s",
  670: "\"",
  671: ":",
  672: "\"",
  673: ".",
  674: ".",
  675: "/",
  676: "l",
  677: "a",
  678: "n",
  679: "g",
  680: "/",
  681: "s",
  682: "l",
  683: "-",
  684: "S",
  685: "I",
  686: ".",
  687: "j",
  688: "s",
  689: "\"",
  690: ",",
  691: "\"",
  692: "f",
  693: "i",
  694: "-",
  695: "F",
  696: "I",
  697: ".",
  698: "j",
  699: "s",
  700: "\"",
  701: ":",
  702: "\"",
  703: ".",
  704: ".",
  705: "/",
  706: "l",
  707: "a",
  708: "n",
  709: "g",
  710: "/",
  711: "f",
  712: "i",
  713: "-",
  714: "F",
  715: "I",
  716: ".",
  717: "j",
  718: "s",
  719: "\"",
  720: ",",
  721: "\"",
  722: "s",
  723: "v",
  724: "-",
  725: "S",
  726: "E",
  727: ".",
  728: "j",
  729: "s",
  730: "\"",
  731: ":",
  732: "\"",
  733: ".",
  734: ".",
  735: "/",
  736: "l",
  737: "a",
  738: "n",
  739: "g",
  740: "/",
  741: "s",
  742: "v",
  743: "-",
  744: "S",
  745: "E",
  746: ".",
  747: "j",
  748: "s",
  749: "\"",
  750: ",",
  751: "\"",
  752: "v",
  753: "i",
  754: "-",
  755: "V",
  756: "N",
  757: ".",
  758: "j",
  759: "s",
  760: "\"",
  761: ":",
  762: "\"",
  763: ".",
  764: ".",
  765: "/",
  766: "l",
  767: "a",
  768: "n",
  769: "g",
  770: "/",
  771: "v",
  772: "i",
  773: "-",
  774: "V",
  775: "N",
  776: ".",
  777: "j",
  778: "s",
  779: "\"",
  780: ",",
  781: "\"",
  782: "t",
  783: "r",
  784: "-",
  785: "T",
  786: "R",
  787: ".",
  788: "j",
  789: "s",
  790: "\"",
  791: ":",
  792: "\"",
  793: ".",
  794: ".",
  795: "/",
  796: "l",
  797: "a",
  798: "n",
  799: "g",
  800: "/",
  801: "t",
  802: "r",
  803: "-",
  804: "T",
  805: "R",
  806: ".",
  807: "j",
  808: "s",
  809: "\"",
  810: ",",
  811: "\"",
  812: "i",
  813: "s",
  814: "-",
  815: "I",
  816: "S",
  817: ".",
  818: "j",
  819: "s",
  820: "\"",
  821: ":",
  822: "\"",
  823: ".",
  824: ".",
  825: "/",
  826: "l",
  827: "a",
  828: "n",
  829: "g",
  830: "/",
  831: "i",
  832: "s",
  833: "-",
  834: "I",
  835: "S",
  836: ".",
  837: "j",
  838: "s",
  839: "\"",
  840: ",",
  841: "\"",
  842: "c",
  843: "s",
  844: "-",
  845: "C",
  846: "Z",
  847: ".",
  848: "j",
  849: "s",
  850: "\"",
  851: ":",
  852: "\"",
  853: ".",
  854: ".",
  855: "/",
  856: "l",
  857: "a",
  858: "n",
  859: "g",
  860: "/",
  861: "c",
  862: "s",
  863: "-",
  864: "C",
  865: "Z",
  866: ".",
  867: "j",
  868: "s",
  869: "\"",
  870: ",",
  871: "\"",
  872: "e",
  873: "l",
  874: "-",
  875: "G",
  876: "R",
  877: ".",
  878: "j",
  879: "s",
  880: "\"",
  881: ":",
  882: "\"",
  883: ".",
  884: ".",
  885: "/",
  886: "l",
  887: "a",
  888: "n",
  889: "g",
  890: "/",
  891: "e",
  892: "l",
  893: "-",
  894: "G",
  895: "R",
  896: ".",
  897: "j",
  898: "s",
  899: "\"",
  900: ",",
  901: "\"",
  902: "s",
  903: "r",
  904: "-",
  905: "S",
  906: "P",
  907: ".",
  908: "j",
  909: "s",
  910: "\"",
  911: ":",
  912: "\"",
  913: ".",
  914: ".",
  915: "/",
  916: "l",
  917: "a",
  918: "n",
  919: "g",
  920: "/",
  921: "s",
  922: "r",
  923: "-",
  924: "S",
  925: "P",
  926: ".",
  927: "j",
  928: "s",
  929: "\"",
  930: ",",
  931: "\"",
  932: "b",
  933: "g",
  934: "-",
  935: "B",
  936: "G",
  937: ".",
  938: "j",
  939: "s",
  940: "\"",
  941: ":",
  942: "\"",
  943: ".",
  944: ".",
  945: "/",
  946: "l",
  947: "a",
  948: "n",
  949: "g",
  950: "/",
  951: "b",
  952: "g",
  953: "-",
  954: "B",
  955: "G",
  956: ".",
  957: "j",
  958: "s",
  959: "\"",
  960: ",",
  961: "\"",
  962: "t",
  963: "l",
  964: "-",
  965: "P",
  966: "H",
  967: ".",
  968: "j",
  969: "s",
  970: "\"",
  971: ":",
  972: "\"",
  973: ".",
  974: ".",
  975: "/",
  976: "l",
  977: "a",
  978: "n",
  979: "g",
  980: "/",
  981: "t",
  982: "l",
  983: "-",
  984: "P",
  985: "H",
  986: ".",
  987: "j",
  988: "s",
  989: "\"",
  990: ",",
  991: "\"",
  992: "u",
  993: "k",
  994: "-",
  995: "U",
  996: "A",
  997: ".",
  998: "j",
  999: "s",
  1000: "\"",
  1001: ":",
  1002: "\"",
  1003: ".",
  1004: ".",
  1005: "/",
  1006: "l",
  1007: "a",
  1008: "n",
  1009: "g",
  1010: "/",
  1011: "u",
  1012: "k",
  1013: "-",
  1014: "U",
  1015: "A",
  1016: ".",
  1017: "j",
  1018: "s",
  1019: "\"",
  1020: ",",
  1021: "\"",
  1022: "t",
  1023: "h",
  1024: "-",
  1025: "T",
  1026: "H",
  1027: ".",
  1028: "j",
  1029: "s",
  1030: "\"",
  1031: ":",
  1032: "\"",
  1033: ".",
  1034: ".",
  1035: "/",
  1036: "l",
  1037: "a",
  1038: "n",
  1039: "g",
  1040: "/",
  1041: "t",
  1042: "h",
  1043: "-",
  1044: "T",
  1045: "H",
  1046: ".",
  1047: "j",
  1048: "s",
  1049: "\"",
  1050: ",",
  1051: "\"",
  1052: "j",
  1053: "a",
  1054: "-",
  1055: "J",
  1056: "P",
  1057: ".",
  1058: "j",
  1059: "s",
  1060: "\"",
  1061: ":",
  1062: "\"",
  1063: ".",
  1064: ".",
  1065: "/",
  1066: "l",
  1067: "a",
  1068: "n",
  1069: "g",
  1070: "/",
  1071: "j",
  1072: "a",
  1073: "-",
  1074: "J",
  1075: "P",
  1076: ".",
  1077: "j",
  1078: "s",
  1079: "\"",
  1080: ",",
  1081: "\"",
  1082: "z",
  1083: "h",
  1084: "-",
  1085: "C",
  1086: "N",
  1087: ".",
  1088: "j",
  1089: "s",
  1090: "\"",
  1091: ":",
  1092: "\"",
  1093: ".",
  1094: ".",
  1095: "/",
  1096: "l",
  1097: "a",
  1098: "n",
  1099: "g",
  1100: "/",
  1101: "z",
  1102: "h",
  1103: "-",
  1104: "C",
  1105: "N",
  1106: ".",
  1107: "j",
  1108: "s",
  1109: "\"",
  1110: ",",
  1111: "\"",
  1112: "z",
  1113: "h",
  1114: "-",
  1115: "T",
  1116: "W",
  1117: ".",
  1118: "j",
  1119: "s",
  1120: "\"",
  1121: ":",
  1122: "\"",
  1123: ".",
  1124: ".",
  1125: "/",
  1126: "l",
  1127: "a",
  1128: "n",
  1129: "g",
  1130: "/",
  1131: "z",
  1132: "h",
  1133: "-",
  1134: "T",
  1135: "W",
  1136: ".",
  1137: "j",
  1138: "s",
  1139: "\"",
  1140: ",",
  1141: "\"",
  1142: "k",
  1143: "o",
  1144: "-",
  1145: "K",
  1146: "R",
  1147: ".",
  1148: "j",
  1149: "s",
  1150: "\"",
  1151: ":",
  1152: "\"",
  1153: ".",
  1154: ".",
  1155: "/",
  1156: "l",
  1157: "a",
  1158: "n",
  1159: "g",
  1160: "/",
  1161: "k",
  1162: "o",
  1163: "-",
  1164: "K",
  1165: "R",
  1166: ".",
  1167: "j",
  1168: "s",
  1169: "\"",
  1170: "}",
}

export const localeMessages = {
  'he-IL.js': () => import('../../lang/he-IL.js' /* webpackChunkName: "lang-he-IL.js" */),
  'en-US.js': () => import('../../lang/en-US.js' /* webpackChunkName: "lang-en-US.js" */),
  'fr-FR.js': () => import('../../lang/fr-FR.js' /* webpackChunkName: "lang-fr-FR.js" */),
  'es-ES.js': () => import('../../lang/es-ES.js' /* webpackChunkName: "lang-es-ES.js" */),
  'ar-SA.js': () => import('../../lang/ar-SA.js' /* webpackChunkName: "lang-ar-SA.js" */),
  'ru-RU.js': () => import('../../lang/ru-RU.js' /* webpackChunkName: "lang-ru-RU.js" */),
  'id-ID.js': () => import('../../lang/id-ID.js' /* webpackChunkName: "lang-id-ID.js" */),
  'ms-MY.js': () => import('../../lang/ms-MY.js' /* webpackChunkName: "lang-ms-MY.js" */),
  'ca-ES.js': () => import('../../lang/ca-ES.js' /* webpackChunkName: "lang-ca-ES.js" */),
  'da-DK.js': () => import('../../lang/da-DK.js' /* webpackChunkName: "lang-da-DK.js" */),
  'de-DE.js': () => import('../../lang/de-DE.js' /* webpackChunkName: "lang-de-DE.js" */),
  'et-EE.js': () => import('../../lang/et-EE.js' /* webpackChunkName: "lang-et-EE.js" */),
  'hr-HR.js': () => import('../../lang/hr-HR.js' /* webpackChunkName: "lang-hr-HR.js" */),
  'it-IT.js': () => import('../../lang/it-IT.js' /* webpackChunkName: "lang-it-IT.js" */),
  'lt-LT.js': () => import('../../lang/lt-LT.js' /* webpackChunkName: "lang-lt-LT.js" */),
  'hu-HU.js': () => import('../../lang/hu-HU.js' /* webpackChunkName: "lang-hu-HU.js" */),
  'nl-NL.js': () => import('../../lang/nl-NL.js' /* webpackChunkName: "lang-nl-NL.js" */),
  'pl-PL.js': () => import('../../lang/pl-PL.js' /* webpackChunkName: "lang-pl-PL.js" */),
  'pt-PT.js': () => import('../../lang/pt-PT.js' /* webpackChunkName: "lang-pt-PT.js" */),
  'pt-BR.js': () => import('../../lang/pt-BR.js' /* webpackChunkName: "lang-pt-BR.js" */),
  'ro-RO.js': () => import('../../lang/ro-RO.js' /* webpackChunkName: "lang-ro-RO.js" */),
  'sk-SK.js': () => import('../../lang/sk-SK.js' /* webpackChunkName: "lang-sk-SK.js" */),
  'sl-SI.js': () => import('../../lang/sl-SI.js' /* webpackChunkName: "lang-sl-SI.js" */),
  'fi-FI.js': () => import('../../lang/fi-FI.js' /* webpackChunkName: "lang-fi-FI.js" */),
  'sv-SE.js': () => import('../../lang/sv-SE.js' /* webpackChunkName: "lang-sv-SE.js" */),
  'vi-VN.js': () => import('../../lang/vi-VN.js' /* webpackChunkName: "lang-vi-VN.js" */),
  'tr-TR.js': () => import('../../lang/tr-TR.js' /* webpackChunkName: "lang-tr-TR.js" */),
  'is-IS.js': () => import('../../lang/is-IS.js' /* webpackChunkName: "lang-is-IS.js" */),
  'cs-CZ.js': () => import('../../lang/cs-CZ.js' /* webpackChunkName: "lang-cs-CZ.js" */),
  'el-GR.js': () => import('../../lang/el-GR.js' /* webpackChunkName: "lang-el-GR.js" */),
  'sr-SP.js': () => import('../../lang/sr-SP.js' /* webpackChunkName: "lang-sr-SP.js" */),
  'bg-BG.js': () => import('../../lang/bg-BG.js' /* webpackChunkName: "lang-bg-BG.js" */),
  'tl-PH.js': () => import('../../lang/tl-PH.js' /* webpackChunkName: "lang-tl-PH.js" */),
  'uk-UA.js': () => import('../../lang/uk-UA.js' /* webpackChunkName: "lang-uk-UA.js" */),
  'th-TH.js': () => import('../../lang/th-TH.js' /* webpackChunkName: "lang-th-TH.js" */),
  'ja-JP.js': () => import('../../lang/ja-JP.js' /* webpackChunkName: "lang-ja-JP.js" */),
  'zh-CN.js': () => import('../../lang/zh-CN.js' /* webpackChunkName: "lang-zh-CN.js" */),
  'zh-TW.js': () => import('../../lang/zh-TW.js' /* webpackChunkName: "lang-zh-TW.js" */),
  'ko-KR.js': () => import('../../lang/ko-KR.js' /* webpackChunkName: "lang-ko-KR.js" */),
}
